<template>
  <div id="recent" v-scroll-reveal>
    <v-container
      fluid
      class="max-height pa-0 ma-0"
    >
      <v-row class="max-height pa-0 ma-0">
        <v-col
          cols="12"
          md="6"
          class="d-flex justify-center align-center max-height"
          id="actual-container"
        >
          <div
            class="recent-text-background"
            id="actual"
            :class="{ nofilter: actualHovered }"
          ></div>
          <h2
            class="recent-text"
            @click="navigateTo('/actual')"
            @mouseover="actualHovered = true"
            @mouseleave="actualHovered = false"
          >
            Aktuális projektjeink
          </h2>
        </v-col>
        <v-col
          cols="12"
          md="6"
          class="d-flex justify-center align-center max-height"
          id="references-container"
        >
          <div
            class="recent-text-background"
            id="references"
            :class="{ nofilter: referencesHovered }"
          ></div>
          <h2
            class="recent-text"
            @click="navigateTo('/references')"
            @mouseover="referencesHovered = true"
            @mouseleave="referencesHovered = false"
          >
            Referenciák
          </h2>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  methods: {
    isMobile() {
      if (
        /Android|webOS|iPhone||iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
    navigateTo: function(route) {
      if(this.isMobile()){ 
        setTimeout(this.$router.push(route), 500);
      } else {
        this.$router.push(route);
      }
    }
  },
  data() {
    return {
      referencesHovered: false,
      actualHovered: false
    };
  }
};
</script>

<style scoped>
#recent {
  height: 600px;
  width: 100%;
  background-color: #212832;
}

.recent-text {
  font-size: 2rem;
  font-weight: 300;
  transition: all 0.6s ease-in-out;
  cursor: pointer;
  z-index: 1;
  transition: all 1s ease-in-out;
  text-shadow: 5px 5px 9px rgba(0, 0, 0, 0.7);
}

.recent-text:hover {
  transform: scale(1.4);
}

.recent-text-background {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 0;
}

#actual {
  background: url("../../assets/actual01.jpg") no-repeat no-repeat center;
  background-size: cover;
  filter: grayscale(50%) brightness(50%) opacity(0.4); /* Current draft standard */
  -webkit-filter: grayscale(50%) brightness(50%) opacity(0.4); /* New WebKit */
  -moz-filter: grayscale(50%) brightness(50%) opacity(0.4);
  -ms-filter: grayscale(50%) brightness(50%) opacity(0.4);
  -o-filter: grayscale(50%) brightness(50%) opacity(0.4); /* Not yet supported in Gecko, Opera or IE */
  filter: gray brightness(50%) opacity(0.4); /* IE */
  -webkit-filter: grayscale(0.5) brightness(50%) opacity(0.4); /* Old WebKit */
}

#references {
  background: url("../../assets/references01.jpg") no-repeat no-repeat center;
  background-size: cover;
  filter: grayscale(50%) brightness(50%) opacity(0.4); /* Current draft standard */
  -webkit-filter: grayscale(50%) brightness(50%) opacity(0.4); /* New WebKit */
  -moz-filter: grayscale(50%) brightness(50%) opacity(0.4);
  -ms-filter: grayscale(50%) brightness(50%) opacity(0.4);
  -o-filter: grayscale(50%) brightness(50%) opacity(0.4); /* Not yet supported in Gecko, Opera or IE */
  filter: gray brightness(50%) opacity(0.4); /* IE */
  -webkit-filter: grayscale(0.5) brightness(50%) opacity(0.4); /* Old WebKit */
}

.nofilter {
  filter: none !important; /* Current draft standard */
  -webkit-filter: none !important; /* New WebKit */
  -moz-filter: none !important;
  -ms-filter: none !important;
  -o-filter: none !important; /* Not yet supported in Gecko, Opera or IE */
  filter: none !important; /* IE */
  -webkit-filter: none !important; /* Old WebKit */
  transition: all 1s ease-in-out !important;
}

#actual-container {
  position: relative;
}

#references-container {
  position: relative;
}

@media screen and (min-width: 601px) and (max-width: 1264px) {
  #recent {
    height: 100%;
    min-height: 35vh;
  }
  #actual-container {
    min-height: 35vh;
  }

  #references-container {
    min-height: 35vh;
  }
}
@media screen and (max-width: 600px) {
  #recent {
    height: 100%;
    min-height: 30vh;
  }
  #actual-container {
    min-height: 30vh;
  }

  #references-container {
    min-height: 30vh;
  }
  .recent-text:hover {
    transform: scale(1.15);
    background-color: rgba(33, 40, 50, 0.3);
  }
}
</style>

